/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_Sub_ItemsInputs */

const en_disp_sub_items = /** @type {(inputs: Disp_Sub_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show sub-items`)
};

const de_disp_sub_items = /** @type {(inputs: Disp_Sub_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untervorgänge zeigen`)
};

/**
* | output |
* | --- |
* | "Show sub-items" |
*
* @param {Disp_Sub_ItemsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_sub_items = /** @type {((inputs?: Disp_Sub_ItemsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_Sub_ItemsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_sub_items(inputs)
	return en_disp_sub_items(inputs)
});